import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
interface TypingIndicatorProps {
  className?: string
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ className }) => {
  return (
    <div className={`my-4 flex items-start gap-3 ${className}`}>
      <div className="flex items-center gap-2 rounded-lg rounded-tl-none px-4 py-3 text-gray-800">
        <span className="ml-1 flex space-x-1">
          <Dot index={0} />
          <Dot index={1} />
          <Dot index={2} />
        </span>
        <span className="font-normal text-primary-500">Escribiendo...</span>
      </div>
    </div>
  )
}

function Dot({ index }: { index: number }) {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      const currentDot = Math.floor((Date.now() / 500) % 3)
      setIsActive(currentDot === index)
    }, 75)

    return () => clearInterval(interval)
  }, [index])

  return (
    <motion.span
      className={`size-2 rounded-full ${isActive ? "bg-primary-500" : "bg-primary-200"}`}
      animate={{
        scale: isActive ? 1.2 : 1,
      }}
      transition={{
        duration: 0.3,
      }}
    />
  )
}
